export default {
  "hideOnDrag": "_hideOnDrag_yf2p1_1",
  "dropBefore": "_dropBefore_yf2p1_6",
  "dropAfter": "_dropAfter_yf2p1_7",
  "dropPop": "_dropPop_yf2p1_1",
  "dropVertical": "_dropVertical_yf2p1_17",
  "dropHorizontal": "_dropHorizontal_yf2p1_23"
};import "ni:sha-256;UqH8igIw0uy20C_32ekFWSuelVlbtC3iW8hMSCz1Ydo";